import React from 'react';
import ReactDOM from 'react-dom';
import { Modal, Button } from 'react-bootstrap';
import CheckBox from '../../assets/checkmark3.svg';

// ✅ Simple function to show a modal with any message
export function showMessageDialog(message, onRedirect) {
  const div = document.createElement('div');
  document.body.appendChild(div);
  ReactDOM.render(
    <TemplateSavedPopup
      message={message}
      onHide={() => closeModal(div)}
      onRedirect={() => {
        closeModal(div);
        if (onRedirect) onRedirect();
      }}
    />,
    div
  );
}

function closeModal(container) {
  ReactDOM.unmountComponentAtNode(container);
  container.remove();
}

const TemplateSavedPopup = ({ message, onHide, onRedirect }) => {
  return (
    <Modal
      show
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ opacity: '1' }}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="w-100 text-center">
          <div className="text-center my-3">
            <img src={CheckBox} style={{ width: '60px', height: 'auto' }} alt="checkmark" />
          </div>
          <p className="modal-title-x mb-0 mt-2">{message}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer className="d-flex justify-content-center">
        <Button className="modal-btn-x" onClick={onRedirect}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TemplateSavedPopup;
